import * as React from "react";
const SvgBadgeEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 11, stroke: "#71747E", strokeWidth: 2 }));
export default SvgBadgeEmpty;
